import * as _ from 'lodash';
import { isPeriodicidadeMensal, isPeriodicidadeTrimestral, isPeriodicidadeSemestral, isPeriodicidadeAnual } from '../../periodicidade';

/** Modos de exibição do datepicker */
export interface DatepickerMode {
    id: number;
    options(): any;
    optionsPeriodicidade?(periodicidade: number): any;
}

/** Modo de exibição por dia do datepicker */
export const datepickerModeDay: DatepickerMode = {
    id: 1,
    options(): any {
        return _.cloneDeep({
            format: 'dd/mm/yyyy',
            todayBtn: 'linked',
            language: 'pt-BR',
            autoclose: true,
            todayHighlight: true,
            assumeNearbyYear: true,
            updateViewDate: false,

            // Atributos personalizados (não são do bootstrap-datepicker)
            mask: '00/00/0000',
            placeholder: '__/__/____'
        });
    }
}

/** Modo de exibição por mês e ano do datepicker */
export const datepickerModeMonthAndYear: DatepickerMode = {
    id: 2,
    options(): any {
        return _.cloneDeep({
            minViewMode: 'months',
            format: 'mm/yyyy',
            todayBtn: false,
            language: 'pt-BR',
            autoclose: true,
            assumeNearbyYear: true,
            updateViewDate: false,

            // Atributos personalizados (não são do bootstrap-datepicker)
            mask: '00/0000',
            placeholder: '__/____'
        });
    }
}


/** Modo de exibição por ano do datepicker */
export const datepickerModeYear: DatepickerMode = {
    id: 3,
    options(): any {
        return _.cloneDeep({
            minViewMode: 'years',
            format: 'yyyy',
            todayBtn: false,
            language: 'pt-BR',
            autoclose: true,
            assumeNearbyYear: true,
            updateViewDate: false,

            // Atributos personalizados (não são do bootstrap-datepicker)
            mask: '0000',
            placeholder: '____'
        })
    }
}

/** Modo de exibição pela periodicidade do datepicker */
export const datepickerModePeriodicidade: DatepickerMode = {
    id: 4,
    options(): any {
        return {};
    },
    optionsPeriodicidade(periodicidade: number): any {
        // Se for a periodicidade trimestral ou semestral ou anual então retorna o modo por ano
        if (isPeriodicidadeTrimestral(periodicidade) || isPeriodicidadeSemestral(periodicidade) || isPeriodicidadeAnual(periodicidade)) {
            return datepickerModeYear.options();
        } else if (isPeriodicidadeMensal(periodicidade)) { // Se for a periodicidade mensal então retorna o modo por mês e ano
            return datepickerModeMonthAndYear.options();
        }

        // Se não, retorna o modo por dia
        return datepickerModeDay.options();
    }
}

/** Modo de exibição custominzado do datepicker */
export const datepickerModeCustom: DatepickerMode = {
    id: 5,
    options(): any {
        return {};
    }
}

/** Verifica se o modo de exibição do datepicker é por dia */
export function isDatepickerModeDay(mode: number): boolean {
    if (!mode) {
        return false;
    }
    return mode === datepickerModeDay.id;
}

/** Verifica se o modo de exibição do datepicker é por mês e ano */
export function isDatepickerModeMonthAndYear(mode: number): boolean {
    if (!mode) {
        return false;
    }
    return mode === datepickerModeMonthAndYear.id;
}

/** Verifica se o modo de exibição do datepicker é por ano */
export function isDatepickerModeYear(mode: number): boolean {
    if (!mode) {
        return false;
    }
    return mode === datepickerModeYear.id;
}

/** Verifica se o modo de exibição do datepicker é pela periodicidade */
export function isDatepickerModePeriodicidade(mode: number): boolean {
    if (!mode) {
        return false;
    }
    return mode === datepickerModePeriodicidade.id;
}

/** Verifica se o modo de exibição do datepicker é customizado */
export function isDatepickerModeCustom(mode: number): boolean {
    if (!mode) {
        return false;
    }
    return mode === datepickerModeCustom.id;
}

/** Obtem as opções do datepicker conforme o modo informado */
export function getDatepickeModeOptions(mode: number, periodicidade: number = null): any {
    switch (mode) {
        case datepickerModeDay.id:
            return datepickerModeDay.options();
        case datepickerModeMonthAndYear.id:
            return datepickerModeMonthAndYear.options();
        case datepickerModeYear.id:
            return datepickerModeYear.options();
        case datepickerModePeriodicidade.id:
            return datepickerModePeriodicidade.optionsPeriodicidade(periodicidade);
        default:
            return {};
    }
}

